<template>
	<div :class="titleShow?'card '+addclass:addclass ">
		<!-- <div class="margin-bottom10 line-height30 font16" >{{title}}</div> -->
		<ComTitle :title="title" size="1" :more="more" @handleMore="handleMore"></ComTitle>
		<div class="" v-for="(item,index) in list" :key="index">
			<!-- 推荐院校 院校排行榜-->
			<div class="margin-top5 flex-betweenCenter margin-bottom20 line-height30 recommend-item" v-if="type==1"
				@click="$toPage('school/'+item.id)">
				<div class="flex-startCenter font16" :class="title=='院校排行榜'?'width70p':''">
					<div class="flex-center width30">
						<img v-if="index==0" src="@/assets/images/icon-rank1.png" class="width30 height19" alt="" />
						<img v-else-if="index==1" src="@/assets/images/icon-rank2.png" class="width30 height19" alt="" />
						<img v-else-if="index==2" src="@/assets/images/icon-rank3.png" class="width30 height19" alt="" />
						<div v-else class="bg-grey width20 height20 border-radius4 font13 color-grey9 flex-center">{{index+1}}</div>
					</div>
					<div class="width30 height30 margin-left8 margin-right6">
						<img :src="item.badge_url" class="recommend-img bg-grey"
							:class="title?'width26 height26':'width30 height30'" alt="" />
					</div>
					<div class="margin-right10 margin-left3 line-1 card-title" :class="title=='院校排行榜'?'width60p':''">{{item.name}}
					</div>
				</div>
				<div class="flex-endCenter color-orange" v-if="title=='院校排行榜'">
					<img src="@/assets/images/icon-hot.png" class="width18 height18" alt="" />
					<div class="">{{item.popularity}}</div>
				</div>
			</div>
			<!--  专业排行榜  推荐专业 -->
			<div class="margin-top5 flex-betweenCenter margin-bottom20 line-height30 recommend-item font16" v-if="type==2"
				@click="$toPage('special/'+item.id) ">
				<div class="flex-startCenter " :class="title=='专业排行榜'?'width70p':''">
					<div class="height30 flex-center">
						<img v-if="index==0" src="@/assets/images/icon-rank1.png" class="width30 height19" alt="" />
						<img v-else-if="index==1" src="@/assets/images/icon-rank2.png" class="width30 height19" alt="" />
						<img v-else-if="index==2" src="@/assets/images/icon-rank3.png" class="width30 height19" alt="" />
						<div v-else class="flex-center width30">
							<div class="bg-grey width20 height20 border-radius4 font13 color-grey9 flex-center">{{index+1}}</div>
						</div>
					</div>
					<div class="margin-left10 line-1 card-title" :class="title=='专业排行榜'?'width60p':''">
						{{item.name||item.professional_name}}
					</div>
				</div>
				<div class="flex-endCenter color-orange" v-if="title=='专业排行榜'">
					<img src="@/assets/images/icon-hot.png" class="width18 height18" alt="" />
					<div class="">{{item.heat}}</div>
				</div>
			</div>

			<!-- 高考资讯  -->
			<div class="margin-top5 flex-startCenter margin-bottom20 line-height24 recommend-item" v-if="type==3"
				@click="$toPage('news/'+item.id)">
				<div class="flex-startCenter font15">
					<div class="width5 height5 border-radius50p bg-blue margin-right10"></div>
					<div class="line-1 card-title width96p">{{item.title}}</div>
				</div>
			</div>

		</div>
	</div>
</template>

<script>
	import * as schoolApi from '@/api/school'
	import * as newsApi from '@/api/news'
	import * as specialApi from '@/api/special'
	export default {
		name: 'RecommendCard',
		props: {
			title: {
				type: String,
				default: '推荐院校'
			},
			titleShow: {
				type: Boolean,
				default: true
			},
			type: {
				type: [String, Number],
				default: 1
			},
			addclass: {
				type: String
			},
			needFetch: {
				type: Boolean,
				default: true // 是否发起请求
			},
			limit: {
				type: [String, Number],
				default: 10
			},
			more: {
				type: String
			},
			cacheExpire: {
				type: Number,
				default: 30 // 缓存过期时间（分钟）
			}
		},
		data() {
			return {
				list: [],
				cachedList: this.initCache(), // 从sessionStorage初始化缓存
				isFetching: false
			}
		},
		computed: {
			typeNum() {
				return Number(this.type)
			},
			// 唯一缓存键：类型+标题+条数（避免冲突）
			cacheKey() {
				return `${this.typeNum}_${this.title}_${this.limit}`
			}
		},
		watch: {
			title: {
				immediate: true,
				handler() {
					this.handleData()
				}
			},
			typeNum: {
				immediate: true,
				handler() {
					this.handleData()
				}
			},
			limit: {
				immediate: true,
				handler() {
					this.handleData()
				}
			},
			needFetch: {
				immediate: true,
				handler() {
					this.handleData()
				}
			}
		},
		methods: {
			// 统一数据处理入口：按needFetch执行不同逻辑
			handleData() {
				if (this.needFetch) {
					// needFetch=true：强制请求接口（忽略缓存），请求后更新缓存
					this.fetchDataForce()
				} else {
					// needFetch=false：优先读缓存，缓存无/过期则请求接口
					this.fetchDataCacheFirst()
				}
			},

			// 初始化缓存（从sessionStorage读取）
			initCache() {
				const cacheStr = sessionStorage.getItem('recommendCardCache')
				return cacheStr ? JSON.parse(cacheStr) : {}
			},

			// 保存缓存（内存+sessionStorage）
			saveCache(key, data) {
				const expireTime = Date.now() + this.cacheExpire * 60 * 1000
				this.cachedList[key] = {
					data,
					expireTime
				}
				sessionStorage.setItem('recommendCardCache', JSON.stringify(this.cachedList))
			},

			// 获取有效缓存（判断是否过期）
			getValidCache(key) {
				const cacheItem = this.cachedList[key]
				if (!cacheItem) return null
				// 缓存过期则删除并返回null
				if (Date.now() > cacheItem.expireTime) {
					delete this.cachedList[key]
					sessionStorage.setItem('recommendCardCache', JSON.stringify(this.cachedList))
					return null
				}
				return cacheItem.data
			},

			// 清空指定缓存
			deleteCache(key) {
				delete this.cachedList[key]
				sessionStorage.setItem('recommendCardCache', JSON.stringify(this.cachedList))
			},

			// 清空所有缓存
			clearAllCache() {
				this.cachedList = {}
				sessionStorage.removeItem('recommendCardCache')
			},

			handleMore() {
				if (this.type == 1) {
					this.$router.push('/school')
				}
				if (this.type == 2 || this.type == 4) {
					this.$router.push('/special')
				}
				if (this.type == 3) {
					this.$router.push('/news')
				}
				// this.$emit('handleMore')
			},

			// 逻辑1：needFetch=true → 强制请求接口（忽略缓存），请求后更新缓存
			async fetchDataForce() {
				if (this.isFetching) return
				try {
					this.isFetching = true
					let res = null
					const params = {
						limit: Number(this.limit)
					}

					// 按类型请求接口
					switch (this.typeNum) {
						case 1:
							res = this.title === '推荐院校' ?
								await schoolApi.recommend(params) :
								await schoolApi.rank(params)
							break
						case 2:
							res = this.title === '推荐专业' ?
								await specialApi.recommend() :
								await specialApi.rank()
							break
						case 3:
							res = await newsApi.list(params)
							break
						default:
							res = {
								data: {
									list: []
								}
							}
					}
					const listData = this.typeNum == 2 ? res?.data || [] : res?.data?.list || []
					this.list = listData
					// 请求成功后更新缓存（覆盖旧缓存）
					this.saveCache(this.cacheKey, listData)
				} catch (err) {
					this.list = []
				} finally {
					this.isFetching = false
				}
			},

			// 逻辑2：needFetch=false → 优先读缓存，缓存无/过期则请求接口
			async fetchDataCacheFirst() {
				// 第一步：读取有效缓存
				const cacheData = this.getValidCache(this.cacheKey)
				if (cacheData) {
					this.list = cacheData
					return // 有缓存则直接使用，不请求接口
				}

				// 第二步：无缓存/缓存过期 → 请求接口
				if (this.isFetching) return
				try {
					this.isFetching = true
					let res = null
					const params = {
						limit: Number(this.limit)
					}

					switch (this.typeNum) {
						case 1:
							res = this.title === '推荐院校' ?
								await schoolApi.recommend(params) :
								await schoolApi.rank(params)
							break
						case 2:
							res = this.title === '推荐专业' ?
								await specialApi.recommend({
									limt: 10
								}) :
								await specialApi.rank()
							break
						case 3:
							res = await newsApi.list(params)
							break
						default:
							res = {
								data: {
									list: []
								}
							}
					}
					const listData = this.typeNum == 2 ? res?.data || [] : res?.data?.list || []
					this.list = listData
					// 保存到缓存
					this.saveCache(this.cacheKey, listData)
				} catch (err) {
					this.list = []
				} finally {
					this.isFetching = false
				}
			},

			// 跳转详情s
			toDetail(type, id) {
				this.$router.push(`/${type}/${id}`)
			}
		}
	}
</script>

<style lang="scss" scoped>
	.recommend-item:hover {
		transform: scale(1.1);
		transition: all 0.3s ease;

		.recommend-img {
			width: 35px;
			height: 35px;
		}
	}
</style>